import { QRFC } from "./QRFC";

export class QUpdateTalentRFC extends QRFC {
  constructor() {
    super();
  }

  InitSetPool(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, data, mode) {
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
    this.AddParameter("data", data);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    var planMgr = callBackObj.fPlanMgr;

    if (success && planMgr) {
      planMgr.UpdateTalentPool(r["data"]);
      planMgr.SetTalentPoolHash(r["talentPoolmd5"]);
      planMgr.UpdateContext();
      callBackObj.resolve?.(r);
    }

    planMgr.CentralResponseAlert(r);
  }
}
